var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSetaBlackFriday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "16px",
    viewBox: "0 0 42 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "12E9688B-5C3B-4590-90C3-D07F4DF09A3A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "renovacao-antecipada/blackfriday",
    transform: "translate(-594.000000, -611.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-arrow",
    transform: "translate(594.000000, 611.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,7 C41.5522847,7 42,7.44771525 42,8 C42,8.51283584 41.6139598,8.93550716 41.1166211,8.99327227 L41,9 L1,9 C0.44771525,9 0,8.55228475 0,8 C0,7.48716416 0.38604019,7.06449284 0.883378875,7.00672773 L1,7 L41,7 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2928932,0.292893219 C33.6533772,-0.0675907428 34.2206082,-0.0953202783 34.6128994,0.209704612 L34.7071068,0.292893219 L41.7071068,7.29289322 C42.0675907,7.65337718 42.0953203,8.22060824 41.7902954,8.61289944 L41.7071068,8.70710678 L34.7071068,15.7071068 C34.3165825,16.0976311 33.6834175,16.0976311 33.2928932,15.7071068 C32.9324093,15.3466228 32.9046797,14.7793918 33.2097046,14.3871006 L33.2928932,14.2928932 L39.585,8 L33.2928932,1.70710678 C32.9324093,1.34662282 32.9046797,0.779391764 33.2097046,0.387100557 L33.2928932,0.292893219 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSetaBlackFriday);
export default __webpack_public_path__ + "static/media/ic-seta-black-friday.02a295171a8e046a083a7933f5d94859.svg";
export { ForwardRef as ReactComponent };